import React from "react";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false, errorMessage: "" };
    }

    static getDerivedStateFromError(error) {
        // Normalize error to string
        const message =
            error instanceof Error
                ? error.stack || error.message
                : typeof error === "string"
                    ? error
                    : JSON.stringify(error);

        return { hasError: true, errorMessage: message };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Error caught by boundary:", error, errorInfo);
    }

    handleReload = () => {
        window.location.reload();
    };

    render() {
        if (this.state.hasError) {
            return (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#f9fafb",
                        padding: "2rem",
                    }}
                >
                    <div
                        style={{
                            background: "#fff",
                            borderRadius: "12px",
                            boxShadow:
                                "0 4px 6px rgba(0, 0, 0, 0.1), 0 12px 24px rgba(0, 0, 0, 0.05)",
                            padding: "2rem",
                            maxWidth: "700px",
                            width: "100%",
                            textAlign: "center",
                        }}
                    >
                        <h1 style={{ fontSize: "1.8rem", color: "#111827", marginBottom: "1rem" }}>
                            ⚠️ Oops, something went wrong
                        </h1>
                        <p style={{ color: "#6b7280", marginBottom: "1.5rem" }}>
                            An unexpected error occurred. You can reload the app to continue.
                        </p>

                        <pre
                            style={{
                                background: "#f3f4f6",
                                color: "#b91c1c",
                                padding: "1rem",
                                borderRadius: "8px",
                                textAlign: "left",
                                maxHeight: "200px",
                                overflowY: "auto",
                                fontSize: "0.85rem",
                                marginBottom: "1.5rem",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                            }}
                        >
                            {this.state.errorMessage}
                        </pre>

                        <button
                            onClick={this.handleReload}
                            style={{
                                background: "#2563eb",
                                color: "#fff",
                                padding: "0.75rem 1.5rem",
                                border: "none",
                                borderRadius: "8px",
                                cursor: "pointer",
                                fontSize: "1rem",
                                fontWeight: "500",
                                transition: "background 0.2s ease-in-out",
                            }}
                            onMouseOver={(e) => (e.target.style.background = "#1e40af")}
                            onMouseOut={(e) => (e.target.style.background = "#2563eb")}
                        >
                            🔄 Reload App
                        </button>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
